import { DisplayElementModel } from './display-element.model';
import { BriefingImageDisplayElementApiModel } from '../../../api/briefings/model/briefing-image-display-element-api.model';
import { ImageStyleModel } from './image-style.model';
import { BriefingImageSettingsModel } from './briefing-image-settings.model';
import { ImageHelper } from '../helpers/image.helper';

export class BriefingChartImageDisplayElementModel extends DisplayElementModel {
    declare styles: ImageStyleModel;
    declare settings: BriefingImageSettingsModel;

    isBoundToGlobalStyles: boolean = true;
    placeholderHeight: number = 120;

    url: string;
    oldUrl: string;

    width: number;

    constructor(
        apiModel: BriefingImageDisplayElementApiModel
    ) {
        super();

        if (apiModel) {
            this.styles = new ImageStyleModel(apiModel.styles);
            this.settings = new BriefingImageSettingsModel(apiModel);
            const {url, width} = apiModel.imageProperties;
            this.url = url;
            this.width = this.styles?.originalWidth || width;
        } else {
            this.styles = new ImageStyleModel();
            this.settings = new BriefingImageSettingsModel();
        }
    }

    canRender(): boolean {
        return !!this.url;
    }

    toApi(): BriefingImageDisplayElementApiModel {
        const settings = this.settings.toApi();

        const apiModel =  <BriefingImageDisplayElementApiModel> {
            styles: JSON.parse(JSON.stringify(this.styles)),
            imageProperties: {
                url: this.url,
                width: this.width,
                ...settings.imageProperties
            },
            link: settings.link,
        };

        return apiModel;
    }

    clone(): BriefingChartImageDisplayElementModel {
        return new BriefingChartImageDisplayElementModel(this.toApi()) as this;
    }

    async onUpdate(): Promise<boolean> {
        let changes = false;

        if (this.url !== this.oldUrl) {
            changes = true;

            if (this.url) {
                try {
                    const width = await ImageHelper.getImageWidth(this.url);
                    this.width = Math.min(width, 640);
                } catch (e) {
                    // Probably couldn't fetch the image
                    if (!this.width) {
                        this.width = 640;
                    }
                }
            } else {
                if (!this.width) {
                    this.width = 640;
                }
            }
        }

        this.oldUrl = this.url;

        return changes;
    }

    isEqual(other: BriefingChartImageDisplayElementModel): boolean {
        if (this.url !== other.url) {
            return false;
        }
        if (!this.styles.equals(other.styles)) {
            return false;
        }
        if (JSON.stringify(this.settings) !== JSON.stringify(other.settings)) {
            return false;
        }
        return true;
    }
}
